import { Icon as IconBase, type IconProps } from "@design-system/Icon";
import { Box, type BoxProps } from "@design-system/Layout/Box";
import { Ellipsis } from "@design-system/Typography/Ellipsis";
import { Text, type TextProps } from "@design-system/Typography/Text";
import { cn } from "@design-system/Utilities";
import { type FC, type Ref } from "react";

type DetailChipComponentType = FC<BoxProps & { ref?: Ref<HTMLDivElement> }> & {
    Icon: typeof DetailChipIcon;
    Label: typeof DetailChipLabel;
};

const DetailChipIcon: FC<IconProps & { ref?: Ref<SVGSVGElement> }> = ({
    ref,
    ...props
}) => {
    return <IconBase size="sm" {...props} ref={ref} />;
};

const DetailChipLabel: FC<TextProps & { ref?: Ref<HTMLDivElement> }> = ({
    ref,
    ...props
}) => {
    return (
        <Ellipsis className="max-w-[20ch]" asChild hasTooltip>
            <Text variant="body-sm-bold" {...props} ref={ref} />
        </Ellipsis>
    );
};

export const DetailChip: DetailChipComponentType = ({
    className,
    children,
    ref,
    ...props
}) => {
    return (
        <Box
            className={cn(
                "inline-flex items-center justify-center",
                "text-primary bg-white",
                "box-border border border-secondary transition-colors ",
                "px-1 py-0.5 gap-0.5 leading-none min-h-5 min-w-5 ",
                "rounded-xl h-fit shadow-b-100",
                "cursor-default",
                className,
            )}
            ref={ref}
            {...props}
        >
            {children}
        </Box>
    );
};

DetailChip.Icon = DetailChipIcon;
DetailChip.Label = DetailChipLabel;
